import type { FreelancerDiplomasInformationPageLocales } from '../types';

const freelancerDiplomasInformationPageLocales: FreelancerDiplomasInformationPageLocales =
  {
    addDiploma: 'Add diploma',
    confirmRemoveDiploma: 'Yes, remove diploma',
    deleteDiplomaMessage:
      'Are you sure you want to delete {{diplomaName}}? If you make a mistake, you can manually add the diploma again.',
    diplomaDeleted: 'Diploma deleted successfully!',
    helperMessage:
      'Add your diplomas below. Please only include degrees relevant to childcare.',
    removeDiploma: 'Remove diploma',
    title: 'Diplomas',
    wantToContinue: 'Are you sure you want to delete this file?',
  };

export default freelancerDiplomasInformationPageLocales;
